import React from 'react';

import Icon from '@components/icon/Icon.tsx';
import handlerPopup from '@functions/handlerPopup.ts';

import I from '../types.ts';

const renderActions: I['renderActions'] = function () {
    const { isFooter } = this.props;

    return (
        <div className="publicTop__actions _ROW">
            {!isFooter && (
                <div
                    className="publicTop__call _CLICK _ROW"
                    onClick={() => {
                        handlerPopup('callPopup', {
                            isShow: true,
                        });
                    }}
                >
                    <i className="publicTop__callIcon">
                        <Icon name="public-call-button" />
                    </i>
                    Перезвоните мне
                </div>
            )}

            <div className="publicTop__copy">
                livecargo CRM 2018-{new Date().getUTCFullYear()} ©
            </div>
        </div>
    );
};

export default renderActions;
